module.exports = __webpack_public_path__ + "static/media/VIP_Pass@3x.4096af24.png";